import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../abstract/base.service';
import { SponsorPointRate } from '../data-models/sponsor-point-rate.model';
import { SponsorPointRateCreateRequest } from '../request-models/sponsor-point-rate-create-request.model';
import { SponsorPointRateUpdateRequest } from '../request-models/sponsor-point-rate-update-request.model';
import {
  toEndSponsorPointRateRequest,
  toSponsorPointRateCreateRequest,
  toSponsorPointRateUpdateRequest,
} from '../utils/sponsor-request-utils';
import { sponsorPrefix } from '../utils/sponsor-path-utils';

/** A sponsor's point rates: `/admin/sponsors/:sponsorId/rates` (hub `admin-sponsors-controller.ts`). */
@Injectable({ providedIn: 'root' })
export class SponsorPointRateService extends BaseService<SponsorPointRate> {
  constructor() {
    super('rates', SponsorPointRate);
  }

  /** GET /admin/sponsors/:sponsorId/rates */
  listRates(sponsorId: string): Observable<SponsorPointRate[]> {
    return this.getMany({ prefix: sponsorPrefix(sponsorId) });
  }

  /** POST /admin/sponsors/:sponsorId/rates */
  createRate(sponsorId: string, fields: SponsorPointRateCreateRequest): Observable<SponsorPointRate | null> {
    return this.create(toSponsorPointRateCreateRequest(fields), { prefix: sponsorPrefix(sponsorId) });
  }

  /** PUT /admin/sponsors/:sponsorId/rates/:rateId (the hub only allows it before the rate starts). */
  updateRate(sponsorId: string, rateId: string, fields: SponsorPointRateUpdateRequest): Observable<SponsorPointRate | null> {
    return this.update(rateId, toSponsorPointRateUpdateRequest(fields), { prefix: sponsorPrefix(sponsorId) });
  }

  /** POST /admin/sponsors/:sponsorId/rates/:rateId/end: sets the rate's end date (`YYYY-MM-DD`). */
  endRate(sponsorId: string, rateId: string, endDate: string): Observable<SponsorPointRate | null> {
    const opts = { prefix: sponsorPrefix(sponsorId), id: rateId, path: 'end' };
    return this.request('POST', opts, toRateOrNull, toEndSponsorPointRateRequest({ endDate }));
  }
}


function toRateOrNull(data: unknown): SponsorPointRate | null {
  return data === null || data === undefined ? null : new SponsorPointRate(data);
}
